<div class="Dialog" mat-dialog-content>
  <div class="Title">{{ data.title }} Example</div>
  <div class="MainImageContainer Flexbox Align--center">
    <div class="InsideImageContainer">
      @for (image of images(); let i = $index; track $index) {
        <img class="MainImage" [class.Active]="i === activeImageIndex()" [src]="image.url">
      }
      <button mat-icon-button class="CloseButton" [mat-dialog-close]><mat-icon>close</mat-icon></button>
    </div>
  </div>
  <div class="PageContainer Flexbox Align--center Justify--center Gap--smaller">
    <button mat-icon-button (click)="activeImage.set(images()[activeImageIndex() - 1].styleImage)" [disabled]="activeImageIndex() <= 0"><mat-icon>chevron_left</mat-icon></button>
    <span>{{ activeImageIndex() + 1 }} / {{ images().length }}</span>
      <button mat-icon-button (click)="activeImage.set(images()[activeImageIndex() + 1].styleImage)" [disabled]="activeImageIndex() >= images().length - 1"><mat-icon>chevron_right</mat-icon></button>
  </div>
</div>